import { Box, CircularProgress } from "@mui/material";
import { not } from "ramda";
import React from "react";
import UsersFilters from "../components/UsersFilters";
import { Spacing } from "../types/enum";
import { useAdminGetGroupedOccupationsQuery } from "../types/graphql";

interface Props {
  filters: any;
  loading: boolean;
  expanded: boolean;
  clearSelection: () => void;
}

const AdvancedSearch: React.FC<Props> = ({ filters, loading, expanded, clearSelection }: Props) => {
  const { data, loading: loadingOccupations } = useAdminGetGroupedOccupationsQuery({
    fetchPolicy: "cache-and-network",
  });

  const occupationOptions = data?.adminGetGroupedOccupations
    ? data?.adminGetGroupedOccupations.map((occupation) => ({
        id: occupation?.id,
        name: occupation?.name,
        groupName: occupation.industry?.name,
      }))
    : [];

  // The industries are already on the occupations, so the wider filter comes
  // free — no second request. Deduped by id, since many jobs share one.
  const industryOptions = Array.from(
    new Map(
      (data?.adminGetGroupedOccupations ?? [])
        .filter((occupation) => occupation.industry)
        .map((occupation) => [
          occupation.industry?.id as string,
          { id: occupation.industry?.id as string, name: occupation.industry?.name as string },
        ]),
    ).values(),
  ).sort((a, b) => a.name.localeCompare(b.name));

  if (loadingOccupations) {
    return <CircularProgress />;
  }

  if (not(expanded)) {
    return null;
  }

  return (
    <Box mb={Spacing.l}>
      <UsersFilters
        filters={filters}
        loading={loading}
        occupationOptions={occupationOptions}
        industryOptions={industryOptions}
        clearSelection={clearSelection}
      />
    </Box>
  );
};

export default AdvancedSearch;
